import { render, staticRenderFns } from "./notification.instance.vue?vue&type=template&id=23edc9d7&"
import script from "./notification.instance.vue?vue&type=script&lang=js&"
export * from "./notification.instance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports